// Word document integration module
export async function getWordDocument(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (typeof Word === 'undefined') {
        reject(new Error("Word API not available"));
        return;
      }
      
      Word.run(async (context) => {
        try {
          const body = context.document.body;
          body.load("text");
          await context.sync();
          resolve(body.text);
        } catch (error) {
          reject(error);
        }
      });
    });
  }
  
  export async function insertIntoWordDocument(content: string, isHtml: boolean = false): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof Word === 'undefined') {
        reject(new Error("Word API not available"));
        return;
      }
      
      Word.run(async (context) => {
        try {
          // Get current selection or insert at cursor position
          const selection = context.document.getSelection();
          
          if (isHtml) {
            // Insert HTML content with formatting
            selection.insertHtml(content, Word.InsertLocation.replace);
          } else {
            // Insert plain text
            selection.insertText(content, Word.InsertLocation.replace);
          }
          
          await context.sync();
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    });
  }
  
  // Add more Word-specific functions as needed
  export const wordService = {
    getWordDocument,
    insertIntoWordDocument,
    
    // Add other Word-specific functions
  };